import { render, staticRenderFns } from "./inforDetails.vue?vue&type=template&id=0e360162&scoped=true"
import script from "./inforDetails.vue?vue&type=script&lang=js"
export * from "./inforDetails.vue?vue&type=script&lang=js"
import style0 from "./inforDetails.vue?vue&type=style&index=0&id=0e360162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e360162",
  null
  
)

export default component.exports